import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { IoHome, IoCall } from "react-icons/io5";
import { MdAlternateEmail } from "react-icons/md";
import { FaFacebookSquare } from "react-icons/fa";
import ScrollToTopButton from "./ScrollToTopButton";

const Contact = () => {
  const form = useRef<HTMLFormElement | null>(null);
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    message: "",
  });
  const [messageSent, setMessageSent] = useState(false);
  const [formIncomplete, setFormIncomplete] = useState(false);

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.user_name || !formData.user_email || !formData.message) {
      setFormIncomplete(true);
      return;
    }

    if (form.current) {
      emailjs
        .sendForm(
          "service_pwzxbh4",
          "template_jni0xsa",
          form.current,
          "KiSDiTZta80qACI_z"
        )
        .then(
          (result) => {
            console.log(result.text);
            console.log("message sent");
            setFormData({
              user_name: "",
              user_email: "",
              message: "",
            });
            setMessageSent(true);
            setFormIncomplete(false);
          },
          (error) => {
            console.log(error.text);
          }
        );
    } else {
      console.error("Form reference is undefined");
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const sendEmailSuccess = (e: any) => {
    e.preventDefault();
    setMessageSent(true);
  };

  return (
    <div>
      <div className="container" id="contact-section">
        <div className="row contact-div">
          <div className="col-lg-6 contact-part">
            <h2 className="contact-title">Get In Touch With May .</h2>
            <div className="contacts mb-3">
              <IoHome fontSize={40} color="#edc74b" />
              <span className="contact-text">
                Address: Chan Aye Thar San, Mandalay{" "}
              </span>
            </div>
            <div className="contacts mb-3">
              <MdAlternateEmail fontSize={40} color="#edc74b" />
              <span className="contact-text">
                Email: sakuramay1210@gmail.com{" "}
              </span>
            </div>
            <div className="contacts mb-3">
              <IoCall fontSize={40} color="#edc74b" />
              <span className="contact-text">Phone: 09-965158633</span>
            </div>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=100009878950363"
                target="_blank"
              >
                <FaFacebookSquare fontSize={30} className="contact-icon" />
              </a>
              <a href="https://www.instagram.com/alwaysoct3/" target="_blank">
                <FaInstagram fontSize={30} className="contact-icon" />
              </a>
              <a
                href="https://www.linkedin.com/in/may-phoo-pyae-san-90510b269/"
                target="_blank"
              >
                <FaLinkedin fontSize={30} className="contact-icon" />
              </a>
            </div>
          </div>

          <div className="col-lg-6 form-container">
            <form ref={form} onSubmit={sendEmail} className="contact-form">
              <div className="mb-3">
                <label htmlFor="user_name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="user_name"
                  name="user_name"
                  value={formData.user_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="user_email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="user_email"
                  name="user_email"
                  value={formData.user_email}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleInputChange}
                ></textarea>
              </div>
              <button type="submit" className="btn btn-primary send-btn">
                Send Message
              </button>
              {formIncomplete && (
                <p className="error-message">
                  Oops! You need to fill in all the fields.
                </p>
              )}
              {messageSent && (
                <p className="thank-you-message">
                  Thank you for contacting me! I will get back to you shortly.
                </p>
              )}
            </form>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <ScrollToTopButton />
        </div>
      </div>
    </div>
  );
};
export default Contact;
